import {useState} from 'react';
import {View} from 'react-native';

import {Dialog, Text, Pressable} from '~/components/controls';
import {LeniencyActionsheet} from '~/components/shared/Actionsheets';
import {isRobLeniencyTask} from '~/types/rob';
import sy from '~/styles';

import MoreVertIcon from '~/images/md-icons/more_vert/materialicons/24px.svg';
import VerifiedUserIcon from '~/images/md-icons/verified_user/materialsymbolsoutlined/24px.svg';
import HealthAndSafetyIcon from '~/images/md-icons/health_and_safety/materialsymbolsoutlined/24px.svg';
import CarCrashIcon from '~/images/md-icons/car_crash/materialsymbolsoutlined/24px.svg';

const WarrantyDialog = ({visible, description, onDismiss}) => (
  <Dialog
    visible={visible}
    title={description}
    onDismiss={onDismiss}
    buttons={[
      {
        text: 'OK',
        onPress: onDismiss,
      },
    ]}
    options={{noPaddingContent: true}}>
    <View style={[sy['flex-row'], sy['gap-4'], sy['p-4']]}>
      <View style={[sy['shrink-0']]}>
        <VerifiedUserIcon fill="#299976" width="24" height="24" />
      </View>
      <Text>
        Garantie toegepast. Bedrag voor activiteit aangepast naar 0,00 euro.
      </Text>
    </View>
  </Dialog>
);

const DamageDialog = ({visible, onDismiss}) => (
  <Dialog
    visible={visible}
    title="Schade"
    onDismiss={onDismiss}
    buttons={[
      {
        text: 'OK',
        onPress: onDismiss,
      },
    ]}
    options={{noPaddingContent: true}}>
    <View style={[sy['flex-row'], sy['gap-4'], sy['p-4']]}>
      <View style={[sy['shrink-0']]}>
        <CarCrashIcon fill="#FF6C00" width="24" height="24" />
      </View>
      <Text>Schadekenmerk toegepast voor activiteit.</Text>
    </View>
  </Dialog>
);

export default ({value, description, ...rest}) => {
  const [showDialog, setShowDialog] = useState(false);

  let icon = <MoreVertIcon {...rest} />;
  let dialog = null;

  if (value.warranty === 'Warranty') {
    icon = <VerifiedUserIcon fill="#299976" {...rest} />;
    dialog = (
      <WarrantyDialog
        visible={showDialog}
        description={description}
        onDismiss={() => setShowDialog(false)}
      />
    );
  } else if (isRobLeniencyTask(value.warranty)) {
    icon = <HealthAndSafetyIcon fill="#FF6C00" {...rest} />;
    dialog = (
      <LeniencyActionsheet
        visible={showDialog}
        value={value.warranty}
        task_amount={value.leniency_amount}
        onDismiss={() => setShowDialog(false)}
      />
    );
  } else if (value.is_damage) {
    icon = <CarCrashIcon fill="#FF6C00" {...rest} />;
    dialog = (
      <DamageDialog
        visible={showDialog}
        onDismiss={() => setShowDialog(false)}
      />
    );
  }

  return (
    <>
      <Pressable onPress={() => setShowDialog(true)}>{icon}</Pressable>
      {dialog}
    </>
  );
};
